export const scrollToId = (id) => {
  if (id === "home") return window.scrollTo({ top: 0, behavior: "smooth" });
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};
